import { useEffect } from "react";
import TapToPayIcon from "./TapToPayIcon";
import Section from "../base/Section";
import { useTapToPay } from "../../hooks/useTapToPay";

/**
 * Highly-visible awareness communication for Tap to Pay on iPhone
 * (Apple requirements 3.1 & 3.3). Shown to every eligible iOS merchant until
 * they accept Apple's Terms & Conditions and finish setup. The button goes
 * straight to the native setup screen, which triggers T&C acceptance
 * (requirement 3.5).
 */
export default function TapToPayBanner() {

    const { shouldShowBanner, markSeen, startSetup } = useTapToPay()

    // Record that the awareness moment has been presented at least once.
    useEffect(() => {
        if (shouldShowBanner) markSeen()
    }, [shouldShowBanner, markSeen])

    if (!shouldShowBanner) return null

    return (
        <Section fluid className="pt-4">
            <div className="notice d-flex bg-light-primary rounded border-primary border border-dashed p-6 align-items-center mb-6">
                <span className="me-4 flex-shrink-0">
                    <TapToPayIcon size={40} className="text-primary" />
                </span>
                <div className="d-flex flex-stack flex-grow-1 flex-wrap gap-3">
                    <div className="fw-bold">
                        <h4 className="text-gray-900 fw-bolder mb-1">Accept payments with Tap to Pay on iPhone</h4>
                        <div className="fs-6 text-gray-700">
                            Take contactless cards and Apple Pay right on your iPhone — no card reader needed.
                            Set it up once to start accepting payments.
                        </div>
                    </div>
                    <button className="btn btn-primary flex-shrink-0"
                        onClick={startSetup}>
                        <TapToPayIcon size={18} className="me-2" />
                        Set up Tap to Pay
                    </button>
                </div>
            </div>
        </Section>
    )
}
